import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  providers: [DatePipe]
})
export class CalendarComponent implements OnInit {
  @Output() dateClicked: EventEmitter<Date> = new EventEmitter<Date>();

  daysInMonth: number[] = [];
  dayHeaders: string[] = ['L', 'M', 'M', 'G', 'V', 'S', 'D'];
  firstDayOfMonth: number = 1
  currentDay = new Date().getDate();
  currentMonth = new Date().getMonth();
  currentYear = new Date().getFullYear();
  now = new Date();
  today: Date = new Date();
  isCurrentDay(day: number): boolean {
    return day === this.today.getDate() && this.currentMonth === this.today.getMonth() && this.currentYear === this.today.getFullYear();
  }


  constructor(public datePipe: DatePipe) { }

  ngOnInit(): void {
    this.generateCalendar(this.currentYear, this.currentMonth);
  }

  generateCalendar(year: number, month: number): void {
    this.firstDayOfMonth = new Date(year, month, 1).getDay();
    this.firstDayOfMonth = (this.firstDayOfMonth + 6) % 7; // Adjust for Italian week starting on Monday
    const days = new Date(year, month + 1, 0).getDate();
    this.daysInMonth = Array.from({ length: days }, (_, i) => i + 1);
  }

  nextMonth(): void {
    if (this.currentMonth === 11) {
      this.currentMonth = 0;
      this.currentYear++;
    } else {
      this.currentMonth++;
    }
    this.generateCalendar(this.currentYear, this.currentMonth);
  }

  previousMonth(): void {
    if (this.currentMonth === 0) {
      this.currentMonth = 11;
      this.currentYear--;
    } else {
      this.currentMonth--;
    }
    this.generateCalendar(this.currentYear, this.currentMonth);
  }

  onDateClick(day: number): void {
    const date = new Date(this.currentYear, this.currentMonth, day);
    this.dateClicked.emit(date);
  }

  onAllEventsClick(): void {
    console.log('All events button clicked');
  }
}
